import feathersClient, { makeServicePlugin, BaseModel } from '@/plugins/feathers-client';

class APIDashboard extends BaseModel {
  constructor(data, options) {
    super(data, options)
  }
  // Required for $FeathersVuex plugin to work after production transpile.
  static modelName = 'APIDashboard'
  // Define default properties here
  static instanceDefaults() {
    return {};
  }
}
const servicePath = '/api/dashboard';
const servicePlugin = makeServicePlugin({
  Model: APIDashboard,
  service: feathersClient.service(servicePath),
  servicePath
});

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [ (context) => {
      console.log(context);
      return context;
    } ],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [ (context) => {
      console.log(context);
      return context;
    } ],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
})

export default servicePlugin